<template>
    <div>
        <div class="row">
            <div class="col">
                <p class="font-weight-bold"> Response </p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-auto">
                <i v-for="count in [1, 2, 3, 4, 5]"
                    :key="count" class="text-primary fa"
                    :class="review.rating >= count ? 'fa-star' : 'fa-star-o'"
                    aria-hidden="true">
                </i>
            </div>
            <div class="col" v-if="review.body">
                <span v-if="!showFullText"> {{ truncatedBody }} <a href="#" @click.prevent="toggleShowText(true)" v-if="!isSmallBody"> Show more</a> </span>
                <span v-if="showFullText"> {{ review.body }} <a href="#" @click.prevent="toggleShowText(false)"> Show less</a> </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['review'],

    data() {
        let body = this.review.body;
        return {
            showFullText: false,
            isSmallBody: body ? body.length <= 150 : false,
            body: this.review.body,
        }
    },

    computed: {
        truncatedBody() {
            return this.body.substring(0, 150);
        }
    },

    methods: {
        toggleShowText(show) {
            this.showFullText = show
        }
    }
}
</script>
